import React, { useState, useEffect, useCallback, useContext } from 'react';
import { observer } from 'mobx-react-lite';
import { Mutual, MutualProps } from '../stores/mutual_store';
// import useStores from '../hooks/useStores';
import { RootStoreContext } from '../stores/root_store';
import useUserIdentity from '../hooks/useUserIdentity';

export type MutualContextType = {
    myMutuals: Mutual[];
    knownMutuals: Mutual[];

    addMyMutual: (identityKey: string) => Promise<void>;
    removeMyMutual: (identityKey: string) => Promise<void>;
    //    isMyMutual: (identityKey: string) => Mutual | undefined;
    isMutual: (identityKey: string, mutualIdentityKey: string) => Mutual | undefined;
    fetchMutualsList: (identityKey: string) => Promise<MutualProps[]>;
    fetchMutualsListed: (identityKey: string) => Promise<MutualProps[]>;
    getMutualsList: (identityKey: string) => Mutual[];
    getMutualsListed: (identityKey: string) => Mutual[];
    setMutualStatus: (identityKey: string, mutualIdentityKey: string, status: string) => Promise<Mutual>;
}

export const MutualContext = React.createContext<MutualContextType>({
    myMutuals: [] as Mutual[],
    knownMutuals: [] as Mutual[],
    addMyMutual: () => { throw "Not implemented" },
    removeMyMutual: () => { throw "Not implemented" },
    //    isMyMutual: () => { throw "Not implemented" },
    isMutual: () => { throw "Not implemented" },
    fetchMutualsList: () => { throw "Not implemented" },
    fetchMutualsListed: () => { throw "Not implemented" },
    getMutualsList: () => { throw "Not implemented" },
    getMutualsListed: () => { throw "Not implemented" },
    setMutualStatus: () => { throw "Not implemented" },
});

export const MutualProvider = observer(({ children }: { children: React.ReactNode }) => {
    const [myMutuals, setMyMutuals] = useState([] as Mutual[]);
    const [knownMutuals, setKnownMutuals] = useState([] as Mutual[])
    // const [knownFetchedList, setKnownFetchedList] = useState([] as string[])
    // const [knownFetchedListed, setKnownFetchedListed] = useState([] as string[])
    const { mutualStore } = useContext(RootStoreContext); //    const { mutualStore } = useStores();
    const { currentIdentity } = useUserIdentity();


    const updateMyMutuals = useCallback(() => {
        if(currentIdentity?.uuid) {
            setMyMutuals(knownMutuals.filter((i: Mutual) => {
                return i.identity == currentIdentity.uuid
            }));
        }
    }, [currentIdentity?.uuid, knownMutuals, setMyMutuals]);

    useEffect(() => {
        setKnownMutuals(mutualStore.items);
    }, [mutualStore.items, setKnownMutuals]);


    useEffect(() => {
        if(currentIdentity?.uuid) {
            mutualStore.fetchList(currentIdentity.uuid).then(updateMyMutuals);
        }
    }, [mutualStore, updateMyMutuals, currentIdentity.uuid]);

    const addMyMutual = (identityKey: string) => {
        return mutualStore
            .create(currentIdentity.uuid, identityKey)
            .then(updateMyMutuals);
    }


    const removeMyMutual = (identityKey: string) => {
        return mutualStore
            .remove(currentIdentity.uuid, identityKey)
            .then(updateMyMutuals);
    }


    // const isMyMutual = (identityKey: string) => {
    //     // return myMutuals.find((i: Mutual) => {
    //     //     return i.mutual_identity === identityKey;
    //     // });

    // };

    const isMutual = (identityKey: string, mutualIdentityKey: string) => {
        return knownMutuals.find((i: Mutual) => {
            return (i.mutual_identity === mutualIdentityKey && i.identity === identityKey)
        });
    };



    // MUTUAL LIST FUNCTIONS
    const getMutualsList = (identityKey: string) => {
        // if(!knownFetchedList.includes(identityKey))  {
        //     setKnownFetchedList([...knownFetchedList, identityKey]);
        //     mutualStore.fetchList(identityKey).then(() => {
        //         setKnownMutuals(mutualStore.items);
        //     });
        // }
        return knownMutuals.filter((i) => i.identity == identityKey);
    }


    const getMutualsListed = (identityKey: string) => {
        // if(!knownFetchedListed.includes(identityKey))  {
        //     setKnownFetchedListed([...knownFetchedListed, identityKey]);
        //     mutualStore.fetchListed(identityKey).then(() => {
        //         setKnownMutuals(mutualStore.items);
        //     });
        // }
        return knownMutuals.filter((i) => i.mutual_identity == identityKey);
    }

    const fetchMutualsList =  async (identityKey: string) => {
        return mutualStore.fetchList(identityKey).then(() => {
            setKnownMutuals(mutualStore.items);
            return mutualStore.items.filter((i) => i.identity == identityKey);
        });
    }

    const fetchMutualsListed = async (identityKey: string) => {
        return mutualStore.fetchListed(identityKey).then(() => {
            console.log("fetchMutualsListed", mutualStore.items);
            setKnownMutuals(mutualStore.items);
            return mutualStore.items.filter((i) => i.mutual_identity == identityKey);
        });
    }

    const setMutualStatus = (identityKey: string, mutualIdentityKey: string, mutualStatus: string) => {
        return mutualStore.setMutualStatus(identityKey, mutualIdentityKey, mutualStatus);
    }

    const data = {
        myMutuals: myMutuals,
        knownMutuals: knownMutuals,
        addMyMutual: addMyMutual,
        removeMyMutual: removeMyMutual,
        //        isMyMutual: isMyMutual,
        isMutual: isMutual,

        getMutualsListed: getMutualsListed,
        getMutualsList: getMutualsList,
        fetchMutualsList: fetchMutualsList,
        fetchMutualsListed: fetchMutualsListed,
        setMutualStatus: setMutualStatus
    };

    return (
        <MutualContext.Provider value={data}>{ children }</MutualContext.Provider>
    );

});
